import { z } from 'zod';
/**
 * Validates a phone number - must be exactly 10 digits
 */
export const validatePhone = (value) => {
    if (!value) {
        return true; // Let required validation handle empty values
    }
    const digits = value.replace(/\D/g, '');
    return digits.length === 10;
};
/**
 * Validates a fax number - must be exactly 10 digits
 */
export const validateFax = (value) => {
    if (!value) {
        return true; // Let required validation handle empty values
    }
    const digits = value.replace(/\D/g, '');
    return digits.length === 10;
};
/**
 * Required phone number validation - must be 10 digits
 */
export const phoneSchema = z.string().min(1, 'Phone is required').refine(validatePhone, {
    message: 'Phone must be 10 digits',
});
/**
 * Optional phone number validation - nullish, but if provided must be 10 digits
 */
export const phoneOptionalSchema = z
    .string()
    .nullish()
    .refine((val) => !val || validatePhone(val), {
    message: 'Phone must be 10 digits',
});
/**
 * Optional phone number with default empty string - if provided must be 10 digits
 */
export const phoneDefaultEmptySchema = z
    .string()
    .default('')
    .refine((val) => !val || validatePhone(val), {
    message: 'Phone must be 10 digits',
});
/**
 * Required fax number validation - must be 10 digits
 */
export const faxSchema = z.string().min(1, 'Fax is required').refine(validateFax, {
    message: 'Fax must be 10 digits',
});
/**
 * Optional fax number validation - nullish, but if provided must be 10 digits
 */
export const faxOptionalSchema = z
    .string()
    .nullish()
    .refine((val) => !val || validateFax(val), {
    message: 'Fax must be 10 digits',
});
/**
 * Optional fax number with default empty string - if provided must be 10 digits
 */
export const faxDefaultEmptySchema = z
    .string()
    .default('')
    .refine((val) => !val || validateFax(val), {
    message: 'Fax must be 10 digits',
});
